import React, { useState, useEffect } from 'react'
import Header from '../Header/Header.js'
import { useNavigate, useLocation } from 'react-router-dom';
import Alert from '../Assets/Alerts.js'
import Loader from '../Assets/Loader.js';
import { getData, putFile, postData } from '../../FetchApiServices.js';

const EditUser = () => {
    let navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const [name, setName] = useState('');
    const [empId, setEmpId] = useState('');
    const [email, setEmail] = useState('');
    const [roleList, setRoleList] = useState([]);
    const [position, setPosition] = useState([]);
    const [position_Id, setPosition_Id] = useState('');
    const [role, setRole] = useState('');
    const [department_Id, setDepartment_Id] = useState('');
    const [section_Id, setSection_Id] = useState('');
    const [sub_Section_Id, setSub_Section_Id] = useState('');
    const [company_Id, setCompany_Id] = useState('');
    const [location_Id, setLocation_Id] = useState('');
    const [phone, setPhone] = useState('');
    const [address, setAddress] = useState('');
    const [status, setStatus] = useState('');
    const [image, setImage] = useState(null);
    const [salutation, setSalutation] = useState('Mr');
    const [password, setPassword] = useState('');
    const [addData, setAddData] = useState("");
    const [departments, setDepartments] = useState([]);
    const [languages, setLanguages] = useState([]);
    const [language_Id, setLanguage_Id] = useState('');
    const [timeZones, setTimeZones] = useState([]);
    const [timeZone_Id, setTimeZone_Id] = useState('');
    const [sections, setSections] = useState([]);
    const [subSections, setSubSections] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [locations, setLocations] = useState([]);
    const [reportingOfficerList, setReportingOfficerList] = useState([]);
    const [reportingOfficer, setReportingOfficer] = useState('0');
    const [visible, setVisible] = useState('');
    const [loading, setLoading] = useState(false);
    const [alert, setAlert] = useState({ type: '', message: '' });


    const fetchUsers = async () => {
        const response = await getData(`users/${state?.id}`);
        if (response.error) {
            setAlert({ type: 'error', message: response.error.message });
        }
        else {
            fillUser(response.data.data[0]);

        }
    }

    const fillUser = (user) => {
        setName(user.name);
        setEmpId(user.emp_id || '');
        setEmail(user.email);
        setRole(user.role);
        setDepartment_Id(user.department_id);
        setSection_Id(user.section_id);
        setSub_Section_Id(user.sub_section_id);
        setCompany_Id(user.company_id);
        setLocation_Id(user.location_id);
        setPhone(user.phone);
        setAddress(user.address);
        setStatus(user.status);
        setLanguage_Id(user.language_code);
        setTimeZone_Id(user.timezone_id);
        setReportingOfficer(user.reporting_officer);
        setPassword("");
        setPosition_Id(user.position_id);
        setImage(user.user_image);
        setSalutation(user?.salutation?.trim() || 'Mr');
    }


    const fetchData = async (endpoint, setState) => {
        const response = await getData(endpoint);
        response && setState(response.data.data || []);
    }

    useEffect(() => {
        fetchData('departments', setDepartments);
        fetchData('sections', setSections);
        fetchData('sub-sections', setSubSections);
        fetchData('companies', setCompanies);
        fetchData('locations', setLocations);
        fetchData('roles', setRoleList);
        fetchData('positions', setPosition);
        fetchData('languages', setLanguages);
        fetchData('timezones', setTimeZones);
        fetchUsers();
    }, []);

    useEffect(() => {
        const fetchReportingOfficer = async () => {
            if (!company_Id || !location_Id || !section_Id || !department_Id) return;
            const response = await postData('users/reporting-officers', { company_id: company_Id, location_id: location_Id, section_id: section_Id, department_id: department_Id });
            if (response.error) {
                setAlert({ type: 'error', message: response.error.message });
            } else {
                setReportingOfficerList(response.data.data);
            }
        }
        fetchReportingOfficer();
    }, [company_Id, location_Id, section_Id, department_Id]);



    const fillDepartments = () => {
        return departments.map(department => (
            <option key={department.department_id} value={department.department_id}>{department.department_name}</option>
        ));
    }
    const fillSections = () => {
        return sections.map(fillSections => (

            <option key={fillSections.section_id} value={fillSections.section_id}>{fillSections.section_name}</option>

        ))
    }
    const fillSubSections = () => {
        return subSections.map(fillSubSections =>
        (
            <option key={fillSubSections.sub_section_id} value={fillSubSections.sub_section_id}>{fillSubSections.sub_section_name}</option>
        )
        )
    }
    const fillCompanies = () => {
        return companies.map(fillCompanies =>
        (
            <option key={fillCompanies.company_id} value={fillCompanies.company_id}>{fillCompanies.company_name}</option>
        )
        )
    }
    const fillLocations = () => {
        return locations.map(fillLocations =>
        (
            <option key={fillLocations.location_id} value={fillLocations.location_id}>{fillLocations.location_name}</option>
        )
        )
    }


    const fillPositions = () => {
        return position.map(fillPositions => (
            <option key={fillPositions.position_id} value={fillPositions.position_id}>{fillPositions.position}</option>
        ));
    }
    const fillRoles = () => {
        if (!Array.isArray(roleList)) {
            console.error("role is not an array");
            return null;
        }
        return roleList.map(fillRoles => (
            <option key={fillRoles.role_id} value={fillRoles.role_id}>{fillRoles.role}</option>
        ));
    }

    const fillLanguages = () => {
        return languages?.map(fillLanguages => (
            <option key={fillLanguages.language_code} value={fillLanguages.language_code}>{fillLanguages.language}</option>
        ));
    }
    const fillTimeZones = () => {
        return timeZones?.map(fillTimeZones => (
            <option key={fillTimeZones.timezone_id} value={fillTimeZones.timezone_id}>{fillTimeZones.timezone}</option>
        ));
    }

    const fillReportingOfficer = () => {
        return reportingOfficerList?.map(fillOfficer => (
            <option key={fillOfficer.position_id} value={fillOfficer.position_id}>{fillOfficer.position}</option>
        ))
    }

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file && !file.type.startsWith('image/')) {
            setAlert({ type: 'error', message: 'Please select a valid image file.' });
            e.target.value = '';
            setImage(null);
            return;
        }
        setImage(file);
    };


    const createNewData = async () => {
        let formData = {};
        if (visible === 'departments') {
            formData = { name: addData };
        } else if (visible === 'sections') {
            formData = { section_name: addData };
        }
        else if (visible === 'sub-sections') {
            formData = { sub_section_name: addData };
        }
        else if (visible === 'companies') {
            formData = { company_name: addData };
        }
        else if (visible === 'locations') {
            formData = { location_name: addData };
        }

        try {
            const response = await postData(visible, formData);
            if (response) {
                if (visible === 'departments') {
                    fetchData('departments', setDepartments);
                    setDepartment_Id(response.data.data.department_id);
                }
                else if (visible === 'sections') {
                    fetchData('sections', setSections);
                    setSection_Id(response.data.data.section_id);
                }
                else if (visible === 'companies') {
                    fetchData('companies', setCompanies);
                    setCompany_Id(response.data.data.company_id);
                }
                else if (visible === 'sub-sections') {
                    fetchData('sub-sections', setSubSections);
                    setSub_Section_Id(response.data.data.sub_section_id);
                }
                else if (visible === 'locations') {
                    fetchData('locations', setLocations);
                    setLocation_Id(response.data.data.location_id);
                }
                setVisible('');
                setAddData('');
                alert(response.message);
            } else {
                console.error(response.message);
            }

        } catch (error) {
            console.error(error);
        }
    };



    const handleChange = (e, set) => {
        const value = e.target.value;
        set(value);


        const types = ['departments', 'sub-sections', 'sections', 'locations', 'companies'];
        const type = types.find(t => value.includes(t));



        if (type) {
            setVisible(type);
        } else {
            setVisible('');
        }
    }





    const handleFormSubmit = async (e) => {
        setLoading(true);
        e.preventDefault();
        const formData = new FormData(e.target);
        formData.append('salutation', salutation || 'Mr');
        formData.append('name', name);
        formData.append('emp_id', empId);
        formData.append('email', email);
        formData.append('role', role);
        formData.append('department_id', department_Id);
        formData.append('section_id', section_Id);
        formData.append('sub_section_id', sub_Section_Id);
        formData.append('company_id', company_Id);
        formData.append('location_id', location_Id);
        formData.append('phone', phone);
        if (address) formData.append('address', address);
        if (password) formData.append('password', password);
        formData.append('position', position_Id);
        formData.append('status', status);
        formData.append('language_code', language_Id);
        formData.append('timezone_id', timeZone_Id);
        formData.append('reporting_officer', reportingOfficer);
        if (image && image instanceof File) formData.append('user_image', image);

        const result = await putFile(`users/${state?.id}`, formData);

        if (result.error) {
            setAlert({ type: 'error', message: result.error.message });
            setLoading(false);
        }
        else {
            setAlert({ type: 'success', message: result.data.message });
            setLoading(false);
            navigate('/view-users');
        }
    }

    // Extract image preview rendering to a variable
    let imagePreview = null;
    if (image && typeof image === 'string' && image !== '') {
        imagePreview = (
            <div className="form-group col-2">
                <img src={image} alt="Preview" width="50" className="img-fluid" />
            </div>
        );
    } else if (image && typeof image === 'object' && image instanceof File) {
        imagePreview = (
            <div className="form-group col-2">
                <img src={URL.createObjectURL(image)} alt="Preview" width="50" className="img-fluid" />
            </div>
        );
    }

    useEffect(() => {
        if (alert.message) {
            const timer = setTimeout(() => {
                setAlert({ type: '', message: '' });
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [alert]);

    return (
        <>
            {loading && <Loader />}
            {alert.message && <Alert type={alert.type} message={alert.message} />}
            <Header title="Edit User" />
            <div className="container-fluid">
                <form onSubmit={handleFormSubmit} className="mt-3">
                    <div className="row align-items-center" >
                        <div className="form-label col-3 text-end">
                            <label htmlFor="email">User Email</label><span className='text-danger'>*</span>

                        </div>
                        <div className="form-group col-7">
                            <input type="email" className="form-control form-control-sm" value={email} onChange={(e) => setEmail(e.target.value)} id="email" placeholder="Enter User Email" required autoComplete="off" />
                        </div>

                        <div className="form-label col-3 text-end">
                            <label htmlFor="name">Name</label>
                            <span className='text-danger'>*</span>
                        </div>
                        <div className="form-group col-1">
                            <select className="form-select form-select-sm w-75" id="" value={salutation} onChange={(e) => setSalutation(e.target.value)}>
                                <option value="Mr">Mr</option>
                                <option value="Ms">Ms</option>
                                <option value="Mrs">Mrs</option>
                            </select>
                        </div>
                        <div className="form-group col-6">
                            <input type="text" className="form-control form-control-sm" id="name" value={name} onChange={(e) => setName(e.target.value)} placeholder="Enter Name" required />
                        </div>

                        <div className="form-label col-3 text-end">
                            <label htmlFor="emp_id">Employee ID</label>
                        </div>
                        <div className="form-group col-7">
                            <input type="text" inputMode="numeric" pattern="[0-9]*" className="form-control form-control-sm" id="emp_id" value={empId} onChange={(e) => setEmpId(e.target.value.replace(/[^0-9]/g, ''))} onKeyDown={(e) => { if (e.ctrlKey || e.metaKey) return; if (['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return; if (!/^[0-9]$/.test(e.key)) e.preventDefault(); }} placeholder="Enter Employee ID" autoComplete="new-password" />
                        </div>

                        <div className="form-label col-3 text-end">
                            <label htmlFor="role">Role</label>
                            <span className='text-danger'>*</span>
                        </div>


                        <div className="form-group col-7">
                            <select className="form-select form-select-sm" id="userRole" value={role} onChange={(e) => setRole(e.target.value)} required>
                                <option value="">Select User Role</option>
                                {fillRoles()}

                            </select>
                        </div>

                        <div className="form-label col-3 text-end">
                            <label htmlFor="company">Company</label>
                            <span className='text-danger'>*</span>
                        </div>
                        <div className="form-group col-7">
                            <select className="form-select form-select-sm" id="company" value={company_Id} onChange={(e) => handleChange(e, setCompany_Id)} required>
                                <option value="">Select one</option>
                                {fillCompanies()}
                                <option value="companies">Add New Company</option>
                            </select>
                        </div>

                        {visible === 'companies' && (<><div className="form-label col-3 text-end">
                            <label htmlFor="company">Add Company</label>
                            <span className='text-danger'>*</span>
                        </div>
                            <div className="form-group col-7 d-flex column-gap-3">
                                <input className="form-control form-control-sm w-50" value={addData} placeholder="Enter Company" onChange={(e) => setAddData(e.target.value)} required /> <button className="btn btn-primary " type="button" onClick={() => createNewData()}>Add</button>
                            </div></>)}



                        <div className="form-label col-3 text-end">
                            <label htmlFor="location">Location</label>
                            <span className='text-danger'>*</span>
                        </div>
                        <div className="form-group col-7">
                            <select className="form-select form-select-sm" id="location" value={location_Id} onChange={(e) => handleChange(e, setLocation_Id)} required>
                                <option value="">Select one</option>
                                {fillLocations()}
                                <option value="locations">Add New Location</option>
                            </select>
                        </div>

                        {visible === 'locations' && (<><div className="form-label col-3 text-end">
                            <label htmlFor="location">Add Location</label>
                            <span className='text-danger'>*</span>
                        </div>
                            <div className="form-group col-7 d-flex column-gap-3">
                                <input className="form-control form-control-sm w-50" value={addData} placeholder="Enter Location" onChange={(e) => setAddData(e.target.value)} required /> <button className="btn btn-primary " type="button" onClick={() => createNewData()}>Add</button>
                            </div></>)}


                        <div className="form-label col-3 text-end">
                            <label htmlFor="section">Section</label>
                            <span className='text-danger'>*</span>
                        </div>
                        <div className="form-group col-7">
                            <select className="form-select form-select-sm notranslate" id="section" value={section_Id} onChange={(e) => handleChange(e, setSection_Id)} required>
                                <option>Select one</option>
                                {fillSections()}
                                <option value="sections">Add New Section</option>
                            </select>
                        </div>

                        {visible === 'sections' && (<><div className="form-label col-3 text-end">
                            <label htmlFor="department">Add Section</label>
                            <span className='text-danger'>*</span>
                        </div>
                            <div className="form-group col-7 d-flex column-gap-3">
                                <input type="text" className="form-control form-control-sm w-50" id="newdepartment" value={addData} onChange={(e) => setAddData(e.target.value)} placeholder="Enter Section" required /> <button className="btn btn-primary " type="button" onClick={() => createNewData()}>Add</button>
                            </div>
                        </>)}

                        <div className="form-label col-3 text-end">
                            <label htmlFor="section">Sub Section</label>
                            <span className='text-danger'>*</span>
                        </div>
                        <div className="form-group col-7">
                            <select className="form-select form-select-sm" id="subsection" value={sub_Section_Id} onChange={(e) => handleChange(e, setSub_Section_Id)} required>
                                <option>Select one</option>
                                {fillSubSections()}
                                <option value="sub-sections">Add New Sub Section</option>
                            </select>
                        </div>

                        {visible === 'sub-sections' && (<> <div className="form-label col-3 text-end">
                            <label htmlFor="section">Add Sub Section</label>
                            <span className='text-danger'>*</span>
                        </div>
                            <div className="form-group col-7 d-flex column-gap-3">
                                <input type="text" className="form-control   form-control-sm w-50" value={addData} placeholder="Enter Sub Section" onChange={(e) => setAddData(e.target.value)} required /> <button className="btn btn-primary " type="button" onClick={() => createNewData()}>Add</button>
                            </div></>)}
                        <div className="form-label col-3 text-end">
                            <label htmlFor="department">Department</label>
                            <span className='text-danger'>*</span>
                        </div>
                        <div className="form-group col-7">
                            <select className="form-select form-select-sm notranslate" id="department" value={department_Id} onChange={(e) => handleChange(e, setDepartment_Id)} required>
                                <option value="">Select one</option>
                                {fillDepartments()}
                                <option value="departments">Add New Department</option>
                            </select>
                        </div>

                        {visible === 'departments' && (<><div className="form-label col-3 text-end">
                            <label htmlFor="department">Add Department</label>
                            <span className='text-danger'>*</span>
                        </div>
                            <div className="form-group col-7 d-flex column-gap-3">
                                <input type="text" className="form-control form-control-sm w-50" id="newdepartment" value={addData} onChange={(e) => setAddData(e.target.value)} placeholder="Enter Department" required /> <button className="btn btn-primary " type="button" onClick={() => createNewData()}>Add</button>
                            </div></>)}


                        <div className="form-label col-3 text-end">
                            <label htmlFor="position">Position</label>
                            <span className='text-danger'>*</span>
                        </div>
                        <div className="form-group col-7">
                            <select className="form-select form-select-sm notranslate" id="position" value={position_Id} onChange={(e) => setPosition_Id(e.target.value)} required>
                                <option value="">Select one</option>
                                {fillPositions()}

                            </select>
                        </div>


                        <div className="form-label col-3 text-end">
                            <label htmlFor="phone">Phone</label>
                            <span className='text-danger'>*</span>
                        </div>
                        <div className="form-group col-7">
                            <input
                                type="tel"
                                className="form-control form-control-sm"
                                id="phone"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value.replace(/\D/g, ""))}
                                placeholder="Enter Phone"
                                required
                            />
                        </div>



                        <div className="form-label col-3 text-end">
                            <label htmlFor="address">Address</label>

                        </div>
                        <div className="form-group col-7">
                            <input type="text" className="form-control form-control-sm" id="address" value={address} onChange={(e) => setAddress(e.target.value)} placeholder="Enter Address" />
                        </div>


                        {/* <div className="form-label col-3 text-end">
                            <label htmlFor="shift">Shift</label>
                            <span className='text-danger'>*</span>
                        </div>
                        <div className="form-group col-7">
                            <select className="form-select form-select-sm" id="shift" value={shift_Id} onChange={(e) => setShift_Id(e.target.value)} required>
                                <option value="">Select one</option>
                                {fillShifts()}
                            </select>
                        </div> */}

                        <div className="form-label col-3 text-end">
                            <label htmlFor="password">Password</label>
                            <span className='text-danger'>*</span>
                        </div>
                        <div className="form-group col-7">
                            <input type="text" className="form-control form-control-sm" id="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Enter Password" autoComplete="new-password" />
                        </div>

                        <div className="form-label col-3 text-end">
                            <label htmlFor="ro">Reporting Position</label>
                            <span className='text-danger'>*</span>
                        </div>
                        <div className="form-group col-7">
                            <select className="form-select form-select-sm" id="ro" value={reportingOfficer} onChange={(e) => setReportingOfficer(e.target.value)} required>
                                <option value="0">Self</option>
                                {fillReportingOfficer()}
                            </select>
                        </div>

                        <div className="form-label col-3 text-end">
                            <label htmlFor="status">User&#39;s Status</label>
                            <span className='text-danger'>*</span>
                        </div>
                        <div className="form-group col-7">
                            <select className="form-select form-select-sm" id="status" value={status} onChange={(e) => setStatus(e.target.value)} required>
                                <option value="1">Active</option>
                                <option value="0">Inactive</option>

                            </select>
                        </div>

                        <div className="form-label col-3 text-end">
                            <label htmlFor="ro">Language</label>
                            <span className='text-danger'>*</span>
                        </div>
                        <div className="form-group col-7">
                            <select name="" className='form-select form-select-sm' id="language" value={language_Id} onChange={(e) => setLanguage_Id(e.target.value)} >
                                <option value="" disabled>Select Language</option>
                                {fillLanguages()}
                            </select>
                        </div>  <div className="form-label col-3 text-end">
                            <label htmlFor="ro">TimeZone</label>
                            <span className='text-danger'>*</span>
                        </div>
                        <div className="form-group col-7">
                            <select name="" className='form-select form-select-sm' id="timezone" value={timeZone_Id} onChange={(e) => setTimeZone_Id(e.target.value)} >
                                <option value="" disabled> Select TimeZone</option>
                                {fillTimeZones()}
                            </select>
                        </div>

                        <div className="form-label col-3 text-end">
                            <label htmlFor="image">Image</label>
                        </div>
                        <div className="form-group col-4">
                            <input type="file" className="form-control form-control-sm" id="image" accept="image/*" onChange={handleImageChange} />
                        </div>
                        {imagePreview}


                        <div className="form-group col-8 text-center mb-5">

                            <button className="btn btn-primary btn-sm " onClick={() => navigate(-1)} type="reset">Cancel</button>
                            <button className="btn btn-success btn-sm mx-2" type="submit" disabled={loading} >Update</button>

                        </div>
                    </div></form >

            </div ></>
    )
}

export default EditUser
